import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "yes-3--sprite",
  "use": "yes-3--sprite-usage",
  "viewBox": "0 0 43 42",
  "content": "<symbol viewBox=\"0 0 43 42\" xmlns=\"http://www.w3.org/2000/svg\" id=\"yes-3--sprite\">\n    <rect x=\"0.5\" y=\"0.5\" width=\"42\" height=\"41\" rx=\"20.5\" fill=\"currentColor\" />\n    <path d=\"M18.2951 24.8749L14.1251 20.7049L12.7051 22.1149L18.2951 27.7049L30.2951 15.7049L28.8851 14.2949L18.2951 24.8749Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol